import {IEventStatus} from "@atl/lacerta-ui-common";

export type EventStatusValue = boolean | number;

export class EventSetsUtils {
    static getStatusValue(status: IEventStatus): EventStatusValue {
        return status.hasOwnProperty('value_bool')
            ? status.value_bool
            : status.value_int64;
    }

    static validateStatuses(statuses: IEventStatus[]): ('NOT_UNIQUE' | 'UNIQUE')[] {
        const frequency = {};
        const values = statuses.map(s => EventSetsUtils.getStatusValue(s));
        values.forEach(value => {
            if (value != undefined) {
                frequency[value.toString()] = (frequency[value.toString()] || 0) + 1;
            }
        });
        return values.map(value => {
            return value == undefined
                ? 'UNIQUE'
                : frequency[value.toString()] > 1
                    ? 'NOT_UNIQUE'
                    : 'UNIQUE';
        });
    }
}
